import { ExtensionDefinition } from "@backstage/frontend-plugin-api";
import { EntityCardBlueprint } from "@backstage/plugin-catalog-react/alpha";
import { isJiraAvailable } from "@roadiehq/backstage-plugin-jira";

/**
 * Entity card for the Jira overview widget.
 *
 * Wraps the legacy {@link EntityJiraOverviewCard} component from
 * `@roadiehq/backstage-plugin-jira`, which does not yet export a native
 * NFS entity-card extension.
 *
 * @deprecated Prefer the Jira tab ({@link jiraContent}) for new entity pages.
 *   This card remains available for layouts that require the compact overview widget.
 */
export const jiraOverviewCard: ExtensionDefinition = EntityCardBlueprint.make({
    name: "jira-overview",
    params: {
        filter: isJiraAvailable,
        loader: () =>
            import("@roadiehq/backstage-plugin-jira").then(m => (
                <m.EntityJiraOverviewCard />
            )),
    },
});
